import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import { Form, Button, Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";

const EditDisease = () => {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [formulas, setFormulas] = useState([]);
  const [message, setMessage] = useState(null);

  const loadData = async () => {
    const diseaseRes = await api.get(`/diseases/${id}`);
    const formulasRes = await api.get("/formulas");
    setForm(diseaseRes.data);
    setFormulas(formulasRes.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  if (!form) return <AdminLayout>Yükleniyor...</AdminLayout>;

  const handleUpdate = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    await api.put(`/diseases/${id}`, form, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setMessage({ type: "success", text: "Hastalık güncellendi!" });
  };

  const handleImageChange = (i, val) => {
    const updated = [...form.imageUrls];
    updated[i] = val;
    setForm({ ...form, imageUrls: updated });
  };

  return (
    <AdminLayout>
      <h2>✏ Hastalık Düzenle</h2>

      {message && <Alert variant={message.type}>{message.text}</Alert>}

      <Form onSubmit={handleUpdate}>
        <Form.Group className="mb-3">
          <Form.Label>Hastalık Adı</Form.Label>
          <Form.Control
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Açıklama</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>İlgili Formüller</Form.Label>
          <Form.Select
            multiple
            value={form.relatedFormulas}
            onChange={(e) =>
              setForm({
                ...form,
                relatedFormulas: [...e.target.selectedOptions].map((o) => o.value),
              })
            }
          >
            {formulas.map((f) => (
              <option value={f._id} key={f._id}>
                {f.formulationName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Label>Resim URL'leri</Form.Label>
        {form.imageUrls.map((url, index) => (
          <Form.Group key={index} className="mb-2">
            <Form.Control
              value={url}
              onChange={(e) => handleImageChange(index, e.target.value)}
            />
          </Form.Group>
        ))}

        <Button type="submit" variant="primary" className="mt-3">
          Güncelle
        </Button>
      </Form>
    </AdminLayout>
  );
};

export default EditDisease;
